/**
 * Created by pzf on 2018/11/1
 *
 */
import { Input, DatePicker, TimePicker, Radio, Switch, InputNumber, Checkbox } from 'mkui-fd';
import CurrencyInput from '../currency-input';
import EnhancedSelect from '../enhanced-select';
var MonthPicker = DatePicker.MonthPicker,
    RangePicker = DatePicker.RangePicker,
    WeekPicker = DatePicker.WeekPicker;
var TextArea = Input.TextArea;
export var COMPONENT_TYPE = {
  'SingleTextInput': 'SINGLE_TEXT_INPUT',
  'MultipleTextInput': 'MULTIPLE_TEXT_INPUT',
  'Select': 'SELECT',
  'DatePicker': 'DATE_PICKER',
  'MonthPicker': 'MONTH_PICKER',
  'WeekPicker': 'WEEK_PICKER',
  'TimePicker': 'TIME_PICKER',
  'DateRangPicker': 'DATE_RANG_PICKER',
  'Radio': 'RADIO',
  'Checkbox ': 'CHECKBOX',
  'NumberInput': 'NUMBER_INPUT',
  'Switch': 'SWITCH',
  'CurrencyInput': 'CURRENCY_INPUT'
};
export var FIELD_MAPPING = {
  SINGLE_TEXT_INPUT: Input,
  MULTIPLE_TEXT_INPUT: TextArea,
  SELECT: EnhancedSelect,
  DATE_PICKER: DatePicker,
  TIME_PICKER: TimePicker,
  MONTH_PICKER: MonthPicker,
  DATE_RANG_PICKER: RangePicker,
  WEEK_PICKER: WeekPicker,
  RADIO: Radio,
  CHECKBOX: Checkbox,
  NUMBER_INPUT: InputNumber,
  CURRENCY_INPUT: CurrencyInput,
  SWITCH: Switch
};
//# sourceMappingURL=constant.js.map
